import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IContact from "../../../../models/IContact";
import OwButton from "../../../shared/OwButton/OwButton";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import UserContext from "../../../../contexts/UserContext";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import AddressBlock from "../../../shared/AddressBlock/AddressBlock";
import OwInputWrapper from "../../../shared/OwInputWrapper/OwInputWrapper";
import INewContact from "../../../../models/INewContact";
import ICreateContactDTO from "../../../../models/DTO/ICreateContactDTO";
import INewAddress from "../../../../models/INewAddress";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import SupplierContext from "../../../../contexts/SupplierContext";
import { Socket } from "socket.io-client";
import IVendorModel from "../../../../models/IVendorModel";
import { OwFnInput } from "../../../shared/OwFnInput/OwFnInput";

type Props = {
    closeSidebarFn: () => void;
    contact?: IContact;
    socket: Socket;
    vendorModel: IVendorModel;
    successFn: (update?: boolean) => void;
};

export const ContactSidebar: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const generateContact = (): INewContact => {
        return {
            name: "",
            email: "",
            mobile: "",
            phone: "",
            vendor_id: 0,
            supplier_id: 0,
        };
    };

    const [contact, setContact] = useState<INewContact>(props.contact || generateContact());
    const [address, setAddress] = useState<INewAddress>(props.contact?.Address ? props.contact.Address : ({} as INewAddress));

    useEffect(() => {
        props.socket.on(EndpointsEnum.ContactsOnCreateContact, onCreateContact);
        props.socket.on(EndpointsEnum.ContactsOnUpdateContact, onUpdateContact);

        return () => {
            props.socket.removeListener(EndpointsEnum.ContactsOnCreateContact, onCreateContact);
            props.socket.removeListener(EndpointsEnum.ContactsOnUpdateContact, onUpdateContact);
        };
    }, []);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        // @ts-expect-error
        const existingContact = {
            ...contact,
        };

        // @ts-expect-error
        existingContact[name] = value;

        setContact(existingContact);
    };

    const handleAddressChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;
        const name = e.target.name;

        // @ts-expect-error
        const existingAddress = {
            ...address,
        };

        // @ts-expect-error
        existingAddress[name] = value;

        setAddress(existingAddress);
    };

    const onCreateContact = () => {
        props.successFn();
    };

    const onUpdateContact = () => {
        props.successFn(true);
    };

    const saveContact = () => {
        const payload: ICreateContactDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            vendorGuid: props.vendorModel.guid,
            contact,
            address,
        };

        if ("guid" in contact) {
            // update the contact
            props.socket.emit(EndpointsEnum.ContactsUpdateContact, payload);
        } else {
            props.socket.emit(EndpointsEnum.ContactsCreateContact, payload);
        }
    };

    return (
        <div className={"ContactSidebar m-4"}>
            <div>
                <div className={"d-flex justify-content-between align-items-center"}>
                    <OwTitle title={"contact"} />
                    <div>
                        <OwButton fn={props.closeSidebarFn} centerIconClass={"fas fa-times"} className={"btn-danger"} />
                    </div>
                </div>
            </div>
            <div className="mt-4">
                <OwLabel title={"name"} />
                <OwFnInput name={"name"} value={contact.name} fn={handleChange} />
            </div>
            <div className="mt-4">
                <OwLabel title={"phone"} />
                <OwFnInput name={"phone"} value={contact.phone} fn={handleChange} />
            </div>
            <div className="mt-4">
                <OwLabel title={"mobile"} />
                <OwFnInput name={"mobile"} value={contact.mobile} fn={handleChange} />
            </div>
            <div className="mt-4">
                <OwLabel title={"email"} />
                <OwFnInput name={"email"} value={contact.email} fn={handleChange} />
            </div>
            <div className="mt-4">
                <OwLabel title={"address"} />
                <AddressBlock fn={handleAddressChange} address={address} />
            </div>
            <div className="mt-4">
                <OwButton title={"save"} fn={saveContact} />
            </div>
        </div>
    );
};
